import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a1a234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "projectHome" }
const _hoisted_2 = { class: "projectInfo" }
const _hoisted_3 = { class: "projectList" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "title backBlue"
}
const _hoisted_6 = {
  key: 1,
  class: "title backYellow"
}
const _hoisted_7 = {
  key: 2,
  class: "title backGray"
}
const _hoisted_8 = {
  key: 3,
  class: "title backGreen"
}
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "people" }
const _hoisted_11 = { class: "head" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 项目经理： ")
const _hoisted_13 = { class: "type" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 项目类型： ")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("提交日志")

import { onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getProjectConfigs } from '@/apis/common'
import { getProjectList } from '@/apis/projectList'
import _lodash from '@/utils/lodashUtil'
import _ from 'lodash'
import { getStaffInfo } from '@/apis/home'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)

const to_declare = () => {
  router.push('/project/declare')
}

const router = useRouter()
const state = reactive({
  update_List: false,
  page: 1,
  project_List: [],
  stage_List: [{ text: '全部阶段', value: 0 }], // 跟进阶段
  status_Type: [{ text: '项目类型', value: 0 }], //
  head_List: [{ text: '全部', value: 0 }]
})

const stage_menu = ref(0)
const status_menu = ref(0)
const searchText = ref('')
const showTabs = ref(true)

const onCancel = () => {
  searchText.value = ''
  showTabs.value = true
}
const onClear = () => {
  searchText.value = ''
}
const binCilck = _.throttle(() => {
  onRefresh()
}, 2000)

watch(searchText, (newVal, old) => {
  // console.log(newVal)
  binCilck()
})

const emptyShow = ref(false)

// 展示查询框
const showSearchText = () => {
  showTabs.value = false
}

const to_addReport = item => {
  // ?project_id=' + item.project_id + '&project_name=' + item.name
  router.push('/project/progress-report/addLog?project_id=' + item.id + '&project_name=' + item.name)
}

const get_list = async () => {
  let rqs = {
    page_size: 10,
    page: state.page,
    name: searchText.value,
    stage: stage_menu.value == 0 ? null : stage_menu.value,
    type_id: status_menu.value == 0 ? null : status_menu.value
  }
  const res = await getProjectList(rqs)
  if (res.code == 200) {
    finished.value = false
    if (refreshing.value) {
      state.project_List = []
      refreshing.value = false
    }
    if (state.update_List) {
      state.project_List = []
      state.update_List = false
    }
    state.page += 1
    state.project_List = _lodash.uniq(_lodash.concat(state.project_List, res.data.data))
    if (state.project_List.length == 0) {
      emptyShow.value = true
    } else {
      emptyShow.value = false
    }

    loading.value = false
    if (state.page > res.data.last_page) {
      // 已到最后一页
      finished.value = true
    }
  }
}

const onRefresh = () => {
  emptyShow.value = false
  // 清空列表数据
  finished.value = false
  state.page = 1
  state.update_List = true
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  get_list()
}

// 选择框查询功能
const get_Configs = async () => {
  let data = {
    name: 'lj_sales_project'
  }
  const res = await getProjectConfigs(data)
  if (res.code == 200) {
    res.data.stage[0] = '全部阶段'
    state.stage_List = Object.keys(res.data.stage).map(item => ({
      text: res.data.stage[item],
      value: Number(item)
    }))
    // 项目类型
    res.data.type[0] = '项目类型'
    for (let i in res.data.type) {
      state.status_Type = Object.keys(res.data.type).map(item => ({
        text: res.data.type[item],
        value: Number(item)
      }))
    }
  }
}
const to_Detail = item => {
  router.push('/project/projectDetail?id=' + item.id + '&showP=true')
  get_Staff_Info()
}
const get_Staff_Info = async () => {
  const res = await getStaffInfo()
  if (res.code === 200) {
    let data = {
      id: res.data.id,
      cf_id: res.data.cf_id,
      is_oadmin: res.data.is_oadmin,
      job_grade: res.data.job_grade,
      jobid: res.data.jobid,
      name: res.data.name,
      parent_id: res.data.parent_id,
      phone_number: res.data.phone_number,
      avatar: res.data.avatar,
      state: res.data.state,
      superior_id: res.data.superior_id,
      type: res.data.type,
      working_state: res.data.avaworking_statetar,
      company_froms: res.data.company_froms,
      jobs: res.data.jobs,
      staff_extend: res.data.staff_extend,
      sex: res.data.sex
    }
    localStorage.setItem('STAFFINFO', JSON.stringify(data))
  }
}

onMounted(() => {
  get_Configs()
})

return (_ctx: any,_cache: any) => {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_sticky, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (showTabs.value)
            ? (_openBlock(), _createBlock(_component_van_dropdown_menu, {
                key: 0,
                "active-color": "#008cff"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_dropdown_item, {
                    modelValue: status_menu.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((status_menu).value = $event)),
                    options: _unref(state).status_Type,
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (onRefresh()))
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode(_component_van_dropdown_item, {
                    modelValue: stage_menu.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stage_menu).value = $event)),
                    options: _unref(state).stage_List,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (onRefresh()))
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showTabs.value)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                size: "24",
                name: "search",
                onClick: showSearchText
              }))
            : (_openBlock(), _createBlock(_component_van_search, {
                key: 2,
                modelValue: searchText.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchText).value = $event)),
                "show-action": "",
                placeholder: "请输入搜索关键词",
                onClear: onClear,
                onCancel: onCancel
              }, null, 8, ["modelValue"]))
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_van_empty, {
            image: "search",
            description: "暂无数据"
          }, null, 512), [
            [_vShow, emptyShow.value]
          ]),
          _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[5] || (_cache[5] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": emptyShow.value ? '' : '没有更多了',
            onLoad: get_list
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).project_List, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "project",
                  key: index,
                  onClick: ($event: any) => (to_Detail(item))
                }, [
                  (item.stage === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.stage_name), 1))
                    : _createCommentVNode("", true),
                  (item.stage === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.stage_name), 1))
                    : _createCommentVNode("", true),
                  (item.stage === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.stage_name), 1))
                    : _createCommentVNode("", true),
                  (item.stage === 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.stage_name), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
                  _createVNode(_component_van_divider, { dashed: "" }),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("span", null, _toDisplayString(item.leader.name || '暂无'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("span", null, _toDisplayString(item.type_name), 1)
                      ])
                    ]),
                    (item.has_daily_log === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_van_button, {
                            plain: "",
                            round: "",
                            size: "small",
                            type: "primary",
                            onClick: _withModifiers(($event: any) => (to_addReport(item)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "finished-text"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})